import { BrowserRouter } from 'react-router-dom';

import { ApplicationLayout } from './application.layout';
import { AppConstants } from './libs/enums';

export function Application() {
  return (
    <BrowserRouter basename={AppConstants.BASENAME}>
      <ApplicationLayout />
    </BrowserRouter>
  );
}
